import React from "react";
import { Box, Grid } from "@mui/material";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDown from "@mui/icons-material/KeyboardDoubleArrowDown";

import EmptyBed from "../../../Svgicons/EmptyBed";
import { BedKpiKey } from "../../../constants/bed";
import { BedKpiCard } from "../Components/BedKpiCard";
import OccupiedBed from "../../../Svgicons/OccupiedBed";
import { TBedKpiKey } from "../../../interfaces/BedInterface";

type GetKpisParams = {
  totalBeds: number;
  availableBeds: number;
  occupiedBeds: number;
  admittedToday: number;
  dischargedToday: number;
};

export const getBedKpis = ({
  totalBeds,
  availableBeds,
  occupiedBeds,
  admittedToday,
  dischargedToday
}: GetKpisParams): Array<{ key: string; title: string; value: number; icon: React.ReactNode }> => [
  {
    key: BedKpiKey.TOTAL_BEDS,
    title: "Total Beds",
    value: totalBeds,
    icon: <BedOutlinedIcon color="success" />
  },
  {
    key: BedKpiKey.AVAILABLE_BEDS,
    title: "Available Beds",
    value: availableBeds,
    icon: <EmptyBed />
  },
  {
    key: BedKpiKey.OCCUPIED_BEDS,
    title: "Occupied Beds",
    value: occupiedBeds,
    icon: <OccupiedBed />
  },
  {
    key: BedKpiKey.ADMITTED_TODAY,
    title: "Admitted Today",
    value: admittedToday,
    icon: <KeyboardDoubleArrowUpIcon color="success" />
  },
  {
    key: BedKpiKey.DISCHARGED_TODAY,
    title: "Discharged Today",
    value: dischargedToday,
    icon: <KeyboardDoubleArrowDown color="warning" />
  }
];

export interface IKpiConfig {
  key: TBedKpiKey | string;
  title: string;
  value: number;
  icon: React.ReactNode;
}

interface BedsKpiProps {
  kpis: IKpiConfig[];
  activeKpiKey: string | null;
  onKpiClick: (key: string) => void;
}

export const BedsKpi: React.FC<BedsKpiProps> = ({ kpis, activeKpiKey, onKpiClick }) => (
  <Box sx={{ p: 2 }}>
    <Grid container spacing={2}>
      {kpis.map((kpi) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }} key={kpi.title}>
          <BedKpiCard
            title={kpi.title}
            value={kpi.value}
            icon={kpi.icon}
            isActive={activeKpiKey === kpi.key}
            onClick={() => onKpiClick(kpi.key as string)}
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default BedsKpi;
